import { css, styled } from 'next-yak';

import { mediaConfined, mediaWide, mediaXWide } from '@xing-com/layout-tokens';
import {
  scale050,
  scale070,
  scale100,
  scale110,
  scale130,
} from '@xing-com/tokens';

import type { BadgeSize } from './badge.types';

type BadgeTransientProps = {
  $size?: BadgeSize;
  $sizeConfined?: BadgeSize;
  $sizeWide?: BadgeSize;
  $sizeXWide?: BadgeSize;
};

// *** Sizes ***
export const sizes = {
  small: css`
    font-size: ${scale050};
    height: ${scale100};
    width: ${scale100};
  `,
  medium: css`
    font-size: ${scale070};
    height: ${scale110};
    width: ${scale110};
  `,
  large: css`
    font-size: ${scale100};
    height: ${scale130};
    width: ${scale130};
  `,
};

// *** Components ***
export const Badge = styled.span<BadgeTransientProps>`
  align-items: center;
  border-radius: 100px;
  display: inline-flex;
  justify-content: center;
  margin: 0;
  padding: 0;

  /** Alignmet fix for IE11 */
  @media all and (-ms-high-contrast: none) {
    padding-top: 3px;
  }

  ${({ $size }) => {
    switch ($size) {
      case 'small':
        return sizes.small;
      case 'medium':
        return sizes.medium;
      case 'large':
        return sizes.large;
      default:
        return $size satisfies undefined;
    }
  }};

  ${({ $sizeConfined }) => {
    switch ($sizeConfined) {
      case 'small':
        return css`
          @media ${mediaConfined} {
            ${sizes.small}
          }
        `;
      case 'medium':
        return css`
          @media ${mediaConfined} {
            ${sizes.medium}
          }
        `;
      case 'large':
        return css`
          @media ${mediaConfined} {
            ${sizes.large}
          }
        `;
      default:
        return $sizeConfined satisfies undefined;
    }
  }};

  ${({ $sizeWide }) => {
    switch ($sizeWide) {
      case 'small':
        return css`
          @media ${mediaWide} {
            ${sizes.small}
          }
        `;
      case 'medium':
        return css`
          @media ${mediaWide} {
            ${sizes.medium}
          }
        `;
      case 'large':
        return css`
          @media ${mediaWide} {
            ${sizes.large}
          }
        `;
      default:
        return $sizeWide satisfies undefined;
    }
  }};

  @media ${mediaXWide} {
    ${({ $sizeXWide }) => {
      switch ($sizeXWide) {
        case 'small':
          return sizes.small;
        case 'medium':
          return sizes.medium;
        case 'large':
          return sizes.large;
        default:
          return $sizeXWide satisfies undefined;
      }
    }};
  }
`;
